import React from 'react';
import PropTypes from 'prop-types';

const badgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '20px',
  height: '20px',
  padding: '0 6px',
  borderRadius: '9999px',
  backgroundColor: 'var(--danger)',
  color: 'white',
  fontSize: 'var(--body-xs-size)',
  fontWeight: 600,
  lineHeight: 1,
};

const NotificationsBadge = ({count}) => {
  return (
    <span style={badgeStyle} aria-label={`Notifications: ${count}`}>
      {count}
    </span>
  );
};

NotificationsBadge.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default NotificationsBadge;
